'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/superlogin-client/~/axios/lib/cancel/isCancel.js
// module id = 429
// module chunks = 7